import React from 'react';
import { FrEventsListHeader } from './fr-events-list-header';
import { FrPageBody } from '../fr-page-layout/fr-page-body';
import { FrQueue } from './fr-queue';

export function FrEventsList() {
    return (
        <>
            <FrEventsListHeader />
            <FrPageBody>
                <FrQueue />
            </FrPageBody>
        </>
    );
}
